import { ModuleConfig, ModuleFields } from "~/Utils/drilldownData";

export const getMediaCentreDrillDownData: { [key in ModuleConfig]: ModuleFields[] } = {
  brandingGuidelinesPageContent: [
    {
      fieldName: "Markup (EN)",
      fieldValue: "data.markup",
      parseField: "field_content_english",
      className: "col-span-12",
      type: "content",
      name: "field_content_english_markup",
      formType: "richText",
      label: "Markup (EN)",
      placeholder: "Enter Markup (EN)",
      validation: { required: "Markup (EN) is required" },
    },
    {
      fieldName: "Markup (MS)",
      fieldValue: "data.markup",
      parseField: "field_content_malay",
      className: "col-span-12",
      type: "content",
      name: "field_content_ms_markup",
      formType: "richText",
      label: "Markup (MS)",
      placeholder: "Enter Markup (MS)",
      validation: {},
    },
    {
      fieldName: "Markup (ZH)",
      fieldValue: "data.markup",
      parseField: "field_content_mandarin",
      className: "col-span-12",
      type: "content",
      name: "field_content_zh_markup",
      formType: "richText",
      label: "Markup (ZH)",
      placeholder: "Enter Markup (ZH)",
      validation: {},
    },
//     {
//       fieldName: "Next Page Name (EN)",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_name",
//       formType: "input",
//       label: "Next Page Name (EN)",
//       placeholder: "Enter Next Page Name (EN)",
//       validation: { required: "Next Page Name (EN) is required" },
//     },
//     {
//       fieldName: "Next Page Name (MS)",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_ms_name",
//       formType: "input",
//       label: "Next Page Name (MS)",
//       placeholder: "Enter Next Page Name (MS)",
//       validation: {},
//     },
//     {
//       fieldName: "Next Page Name (ZH)",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_zh_name",
//       formType: "input",
//       label: "Next Page Name (ZH)",
//       placeholder: "Enter Next Page Name (ZH)",
//       validation: {},
//     },
//     {
//       fieldName: "Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_link",
//       formType: "input",
//       label: "Next Page Link",
//       placeholder: "Enter Next Page Link",
//       validation: { required: "Next Page Link is required",  validate: (value: string) => {
//   const trimmed = value.trim();
//   if (!trimmed.startsWith("/")) return "Please use an in-app page link, such as /example";
//   if (["http://", "https://", "www."].some(p => trimmed.includes(p))) {
//     return "Looks like an external link. Please use an in-app page link, such as /example";
//   }
//   return true;
// }  },
//     },
    // {
    //   fieldName: "Next Page Link (MS)",
    //   fieldValue: "data.nextPage.link",
    //   parseField: "field_content_malay",
    //   className: "col-span-6",
    //   type: "content",
    //   name: "field_content_ms_link",
    //   formType: "input",
    //   label: "Next Page Link (MS)",
    //   placeholder: "Enter Next Page Link (MS)",
    //   validation: {},
    // },
    // {
    //   fieldName: "Next Page Link (ZH)",
    //   fieldValue: "data.nextPage.link",
    //   parseField: "field_content_mandarin",
    //   className: "col-span-6",
    //   type: "content",
    //   name: "field_content_zh_link",
    //   formType: "input",
    //   label: "Next Page Link (ZH)",
    //   placeholder: "Enter Next Page Link (ZH)",
    //   validation: {},
    // },
  ],
  brandingGuidelinesNextPage: [
    {
      fieldName: "Next Page Name (EN)",
      fieldValue: "data.nextPage.name",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_name",
      formType: "input",
      label: "Next Page Name (EN)",
      placeholder: "Enter Next Page Name (EN)",
      validation: { required: "Next Page Name (EN) is required" },
    },
    {
      fieldName: "Next Page Name (MS)",
      fieldValue: "data.nextPage.name",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "content",
      name: "field_content_ms_name",
      formType: "input",
      label: "Next Page Name (MS)",
      placeholder: "Enter Next Page Name (MS)",
      validation: {},
    },
    {
      fieldName: "Next Page Name (ZH)",
      fieldValue: "data.nextPage.name",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "content",
      name: "field_content_zh_name",
      formType: "input",
      label: "Next Page Name (ZH)",
      placeholder: "Enter Next Page Name (ZH)",
      validation: {},
    },
    {
      fieldName: "Next Page Link",
      fieldValue: "data.nextPage.link",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_link",
      formType: "input",
      label: "Next Page Link",
      placeholder: "Enter Next Page Link",
      validation: { required: "Next Page Link is required",  validate: (value: string) => {
  const trimmed = value.trim();
  if (!trimmed.startsWith("/")) return "Please use an in-app page link, such as /example";
  if (["http://", "https://", "www."].some(p => trimmed.includes(p))) {
    return "Looks like an external link. Please use an in-app page link, such as /example";
  }
  return true;
}  },
    },
    // {
    //   fieldName: "Next Page Link (MS)",
    //   fieldValue: "data.nextPage.link",
    //   parseField: "field_content_malay",
    //   className: "col-span-6",
    //   type: "content",
    //   name: "field_content_ms_link",
    //   formType: "input",
    //   label: "Next Page Link (MS)",
    //   placeholder: "Enter Next Page Link (MS)",
    //   validation: {},
    // },
    // {
    //   fieldName: "Next Page Link (ZH)",
    //   fieldValue: "data.nextPage.link",
    //   parseField: "field_content_mandarin",
    //   className: "col-span-6",
    //   type: "content",
    //   name: "field_content_zh_link",
    //   formType: "input",
    //   label: "Next Page Link (ZH)",
    //   placeholder: "Enter Next Page Link (ZH)",
    //   validation: {},
    // },
  ],
  news: [
    {
      fieldName: "Image",
      fieldValue: "field_news_images",
      className: "col-span-6",
      type: "image",
      name: "field_news_images",
      formType: "file",
      usedFileType: 'image/*',
      label: "Image",
      placeholder: "Enter Image URL",
      // validation: { required: "Image is required" },
    },
    // {
    //   fieldName: "Item Count",
    //   fieldValue: "item_count",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "item_count",
    //   formType: "input",
    //   label: "Item Count",
    //   placeholder: "Enter Item Count",
    //   validation: { required: "Item Count is required" },
    // },
    {
      fieldName: "Title (EN)",
      fieldValue: "field_news_title_en",
      className: "col-span-6",
      type: "text",
      name: "field_news_title_en",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Title (MS)",
      fieldValue: "field_news_title_ms",
      className: "col-span-6",
      type: "text",
      name: "field_news_title_ms",
      formType: "input",
      label: "Title (MS)",
      placeholder: "Enter Title (MS)",
      // validation: { required: "Title (MS) is required" },
    },
    {
      fieldName: "Title (ZH)",
      fieldValue: "field_news_title_zh",
      className: "col-span-6",
      type: "text",
      name: "field_news_title_zh",
      formType: "input",
      label: "Title (ZH)",
      placeholder: "Enter Title (ZH)",
      // validation: { required: "Title (ZH) is required" },
    },
    {
      fieldName: "Date",
      fieldValue: "field_news_date",
      className: "col-span-6",
      type: "dateTime",
      name: "field_news_date",
      formType: "dateTime",
      label: "Date",
      placeholder: "Select Date",
      validation: { required: "Date is required" },
      futureDateRestriction: true
    },
    {
      fieldName: "Description (EN)",
      fieldValue: "field_news_description_en",
      className: "col-span-6",
      type: "text",
      name: "field_news_description_en",
      formType: "richText",
      label: "Description (EN)",
      placeholder: "Enter Description (EN)",
      validation: { required: "Description (EN) is required" },
    },
    {
      fieldName: "Description (MS)",
      fieldValue: "field_news_description_ms",
      className: "col-span-6",
      type: "text",
      name: "field_news_description_ms",
      formType: "richText",
      label: "Description (MS)",
      placeholder: "Enter Description (MS)",
      // validation: { required: "Description (MS) is required" },
    },
    {
      fieldName: "Description (ZH)",
      fieldValue: "field_news_description_zh",
      className: "col-span-6",
      type: "text",
      name: "field_news_description_zh",
      formType: "richText",
      label: "Description (ZH)",
      placeholder: "Enter Description (ZH)",
      // validation: { required: "Description (ZH) is required" },
    },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    }
  ],
  brandingGuidelinesPageHeading: [
    {
      fieldName: "Banner Image",
      fieldValue: "field_page_banner_image",
      className: "col-span-6",
      type: "image",
      name: "field_page_banner_image",
      formType: "file",
      usedFileType: 'image/*',
      label: "Banner Image",
      placeholder: "Enter Banner Image URL",
      validation: { required: "Banner Image is required" },
    },
    {
      fieldName: "Page Title (EN)",
      fieldValue: "field_page_title_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_en",
      formType: "input",
      label: "Page Title (EN)",
      placeholder: "Enter Page Title (EN)",
      validation: { required: "Page Title (EN) is required" },
    },
    {
      fieldName: "Page Title (MS)",
      fieldValue: "field_page_title_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_ms",
      formType: "input",
      label: "Page Title (MS)",
      placeholder: "Enter Page Title (MS)",
      // validation: { required: "Page Title (MS) is required" },
    },
    {
      fieldName: "Page Title (ZH)",
      fieldValue: "field_page_title_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_zh",
      formType: "input",
      label: "Page Title (ZH)",
      placeholder: "Enter Page Title (ZH)",
      // validation: { required: "Page Title (ZH) is required" },
    },
    {
      fieldName: "Page Description (EN)",
      fieldValue: "field_page_description_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_en",
      formType: "richText",
      label: "Page Description (EN)",
      placeholder: "Enter Page Description (EN)",
      // validation: { required: "Page Description (EN) is required" },
    },
    {
      fieldName: "Page Description (MS)",
      fieldValue: "field_page_description_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_ms",
      formType: "richText",
      label: "Page Description (MS)",
      placeholder: "Enter Page Description (MS)",
      // validation: { required: "Page Description (MS) is required" },
    },
    {
      fieldName: "Page Description (ZH)",
      fieldValue: "field_page_description_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_zh",
      formType: "richText",
      label: "Page Description (ZH)",
      placeholder: "Enter Page Description (ZH)",
      // validation: { required: "Page Description (ZH) is required" },
    },
    // {
    //   fieldName: "Metadata Image",
    //   fieldValue: "field_page_metadata_image",
    //   className: "col-span-6",
    //   type: "image",
    //   name: "field_page_metadata_image",
    //   formType: "file",
    //   usedFileType: 'image/*',
    //   label: "Metadata Image",
    //   placeholder: "Enter Metadata Image URL",
    //   validation: { required: "Metadata Image is required" },
    // },
    // {
    //   fieldName: "Metadata Title (EN)",
    //   fieldValue: "field_page_metadata_title_en",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_title_en",
    //   formType: "input",
    //   label: "Metadata Title (EN)",
    //   placeholder: "Enter Metadata Title (EN)",
    //   validation: { required: "Metadata Title (EN) is required" },
    // },
    // {
    //   fieldName: "Metadata Title (MS)",
    //   fieldValue: "field_page_metadata_title_ms",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_title_ms",
    //   formType: "input",
    //   label: "Metadata Title (MS)",
    //   placeholder: "Enter Metadata Title (MS)",
    //   // validation: { required: "Metadata Title (MS) is required" },
    // },
    // {
    //   fieldName: "Metadata Title (ZH)",
    //   fieldValue: "field_page_metadata_title_zh",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_title_zh",
    //   formType: "input",
    //   label: "Metadata Title (ZH)",
    //   placeholder: "Enter Metadata Title (ZH)",
    //   // validation: { required: "Metadata Title (ZH) is required" },
    // },
    // {
    //   fieldName: "Metadata Description (EN)",
    //   fieldValue: "field_page_metadata_desc_en",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_desc_en",
    //   formType: "richText",
    //   label: "Metadata Description (EN)",
    //   placeholder: "Enter Metadata Description (EN)",
    //   validation: { required: "Metadata Description (EN) is required" },
    // },
    // {
    //   fieldName: "Metadata Description (MS)",
    //   fieldValue: "field_page_metadata_desc_ms",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_desc_ms",
    //   formType: "richText",
    //   label: "Metadata Description (MS)",
    //   placeholder: "Enter Metadata Description (MS)",
    //   // validation: { required: "Metadata Description (MS) is required" },
    // },
    // {
    //   fieldName: "Metadata Description (ZH)",
    //   fieldValue: "field_page_metadata_desc_zh",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_desc_zh",
    //   formType: "richText",
    //   label: "Metadata Description (ZH)",
    //   placeholder: "Enter Metadata Description (ZH)",
    //   // validation: { required: "Metadata Description (ZH) is required" },
    // },
  ],
  newsPageHeading: [
    {
      fieldName: "Banner Image",
      fieldValue: "field_page_banner_image",
      className: "col-span-6",
      type: "image",
      name: "field_page_banner_image",
      formType: "file",
      usedFileType: 'image/*',
      label: "Banner Image",
      placeholder: "Enter Banner Image URL",
      validation: { required: "Banner Image is required" },
    },
    {
      fieldName: "Page Title (EN)",
      fieldValue: "field_page_title_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_en",
      formType: "input",
      label: "Page Title (EN)",
      placeholder: "Enter Page Title (EN)",
      validation: { required: "Page Title (EN) is required" },
    },
    {
      fieldName: "Page Title (MS)",
      fieldValue: "field_page_title_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_ms",
      formType: "input",
      label: "Page Title (MS)",
      placeholder: "Enter Page Title (MS)",
      // validation: { required: "Page Title (MS) is required" },
    },
    {
      fieldName: "Page Title (ZH)",
      fieldValue: "field_page_title_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_zh",
      formType: "input",
      label: "Page Title (ZH)",
      placeholder: "Enter Page Title (ZH)",
      // validation: { required: "Page Title (ZH) is required" },
    },
    {
      fieldName: "Page Description (EN)",
      fieldValue: "field_page_description_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_en",
      formType: "richText",
      label: "Page Description (EN)",
      placeholder: "Enter Page Description (EN)",
      // validation: { required: "Page Description (EN) is required" },
    },
    {
      fieldName: "Page Description (MS)",
      fieldValue: "field_page_description_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_ms",
      formType: "richText",
      label: "Page Description (MS)",
      placeholder: "Enter Page Description (MS)",
      // validation: { required: "Page Description (MS) is required" },
    },
    {
      fieldName: "Page Description (ZH)",
      fieldValue: "field_page_description_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_zh",
      formType: "richText",
      label: "Page Description (ZH)",
      placeholder: "Enter Page Description (ZH)",
      // validation: { required: "Page Description (ZH) is required" },
    },
    // {
    //   fieldName: "Metadata Image",
    //   fieldValue: "field_page_metadata_image",
    //   className: "col-span-6",
    //   type: "image",
    //   name: "field_page_metadata_image",
    //   formType: "file",
    //   usedFileType: 'image/*',
    //   label: "Metadata Image",
    //   placeholder: "Enter Metadata Image URL",
    //   validation: { required: "Metadata Image is required" },
    // },
    // {
    //   fieldName: "Metadata Title (EN)",
    //   fieldValue: "field_page_metadata_title_en",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_title_en",
    //   formType: "input",
    //   label: "Metadata Title (EN)",
    //   placeholder: "Enter Metadata Title (EN)",
    //   validation: { required: "Metadata Title (EN) is required" },
    // },
    // {
    //   fieldName: "Metadata Title (MS)",
    //   fieldValue: "field_page_metadata_title_ms",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_title_ms",
    //   formType: "input",
    //   label: "Metadata Title (MS)",
    //   placeholder: "Enter Metadata Title (MS)",
    //   // validation: { required: "Metadata Title (MS) is required" },
    // },
    // {
    //   fieldName: "Metadata Title (ZH)",
    //   fieldValue: "field_page_metadata_title_zh",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_title_zh",
    //   formType: "input",
    //   label: "Metadata Title (ZH)",
    //   placeholder: "Enter Metadata Title (ZH)",
    //   // validation: { required: "Metadata Title (ZH) is required" },
    // },
    // {
    //   fieldName: "Metadata Description (EN)",
    //   fieldValue: "field_page_metadata_desc_en",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_desc_en",
    //   formType: "richText",
    //   label: "Metadata Description (EN)",
    //   placeholder: "Enter Metadata Description (EN)",
    //   validation: { required: "Metadata Description (EN) is required" },
    // },
    // {
    //   fieldName: "Metadata Description (MS)",
    //   fieldValue: "field_page_metadata_desc_ms",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_desc_ms",
    //   formType: "richText",
    //   label: "Metadata Description (MS)",
    //   placeholder: "Enter Metadata Description (MS)",
    //   // validation: { required: "Metadata Description (MS) is required" },
    // },
    // {
    //   fieldName: "Metadata Description (ZH)",
    //   fieldValue: "field_page_metadata_desc_zh",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_desc_zh",
    //   formType: "richText",
    //   label: "Metadata Description (ZH)",
    //   placeholder: "Enter Metadata Description (ZH)",
    //   // validation: { required: "Metadata Description (ZH) is required" },
    // },
  ],
  latestNewsPageHeading: [
    {
      fieldName: "Banner Image",
      fieldValue: "field_page_banner_image",
      className: "col-span-6",
      type: "image",
      name: "field_page_banner_image",
      formType: "file",
      usedFileType: 'image/*',
      label: "Banner Image",
      placeholder: "Enter Banner Image URL",
      validation: { required: "Banner Image is required" },
    },
    {
      fieldName: "Page Title (EN)",
      fieldValue: "field_page_title_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_en",
      formType: "input",
      label: "Page Title (EN)",
      placeholder: "Enter Page Title (EN)",
      validation: { required: "Page Title (EN) is required" },
    },
    {
      fieldName: "Page Title (MS)",
      fieldValue: "field_page_title_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_ms",
      formType: "input",
      label: "Page Title (MS)",
      placeholder: "Enter Page Title (MS)",
      // validation: { required: "Page Title (MS) is required" },
    },
    {
      fieldName: "Page Title (ZH)",
      fieldValue: "field_page_title_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_zh",
      formType: "input",
      label: "Page Title (ZH)",
      placeholder: "Enter Page Title (ZH)",
      // validation: { required: "Page Title (ZH) is required" },
    },
    {
      fieldName: "Page Description (EN)",
      fieldValue: "field_page_description_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_en",
      formType: "richText",
      label: "Page Description (EN)",
      placeholder: "Enter Page Description (EN)",
      // validation: { required: "Page Description (EN) is required" },
    },
    {
      fieldName: "Page Description (MS)",
      fieldValue: "field_page_description_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_ms",
      formType: "richText",
      label: "Page Description (MS)",
      placeholder: "Enter Page Description (MS)",
      // validation: { required: "Page Description (MS) is required" },
    },
    {
      fieldName: "Page Description (ZH)",
      fieldValue: "field_page_description_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_zh",
      formType: "richText",
      label: "Page Description (ZH)",
      placeholder: "Enter Page Description (ZH)",
      // validation: { required: "Page Description (ZH) is required" },
    },
    // {
    //   fieldName: "Metadata Image",
    //   fieldValue: "field_page_metadata_image",
    //   className: "col-span-6",
    //   type: "image",
    //   name: "field_page_metadata_image",
    //   formType: "file",
    //   usedFileType: 'image/*',
    //   label: "Metadata Image",
    //   placeholder: "Enter Metadata Image URL",
    //   validation: { required: "Metadata Image is required" },
    // },
    // {
    //   fieldName: "Metadata Title (EN)",
    //   fieldValue: "field_page_metadata_title_en",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_title_en",
    //   formType: "input",
    //   label: "Metadata Title (EN)",
    //   placeholder: "Enter Metadata Title (EN)",
    //   validation: { required: "Metadata Title (EN) is required" },
    // },
    // {
    //   fieldName: "Metadata Title (MS)",
    //   fieldValue: "field_page_metadata_title_ms",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_title_ms",
    //   formType: "input",
    //   label: "Metadata Title (MS)",
    //   placeholder: "Enter Metadata Title (MS)",
    //   // validation: { required: "Metadata Title (MS) is required" },
    // },
    // {
    //   fieldName: "Metadata Title (ZH)",
    //   fieldValue: "field_page_metadata_title_zh",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_title_zh",
    //   formType: "input",
    //   label: "Metadata Title (ZH)",
    //   placeholder: "Enter Metadata Title (ZH)",
    //   // validation: { required: "Metadata Title (ZH) is required" },
    // },
    // {
    //   fieldName: "Metadata Description (EN)",
    //   fieldValue: "field_page_metadata_desc_en",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_desc_en",
    //   formType: "richText",
    //   label: "Metadata Description (EN)",
    //   placeholder: "Enter Metadata Description (EN)",
    //   validation: { required: "Metadata Description (EN) is required" },
    // },
    // {
    //   fieldName: "Metadata Description (MS)",
    //   fieldValue: "field_page_metadata_desc_ms",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_desc_ms",
    //   formType: "richText",
    //   label: "Metadata Description (MS)",
    //   placeholder: "Enter Metadata Description (MS)",
    //   // validation: { required: "Metadata Description (MS) is required" },
    // },
    // {
    //   fieldName: "Metadata Description (ZH)",
    //   fieldValue: "field_page_metadata_desc_zh",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_desc_zh",
    //   formType: "richText",
    //   label: "Metadata Description (ZH)",
    //   placeholder: "Enter Metadata Description (ZH)",
    //   // validation: { required: "Metadata Description (ZH) is required" },
    // },
  ],
  archivesNewsPageHeading: [
    {
      fieldName: "Banner Image",
      fieldValue: "field_page_banner_image",
      className: "col-span-6",
      type: "image",
      name: "field_page_banner_image",
      formType: "file",
      usedFileType: 'image/*',
      label: "Banner Image",
      placeholder: "Enter Banner Image URL",
      validation: { required: "Banner Image is required" },
    },
    {
      fieldName: "Page Title (EN)",
      fieldValue: "field_page_title_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_en",
      formType: "input",
      label: "Page Title (EN)",
      placeholder: "Enter Page Title (EN)",
      validation: { required: "Page Title (EN) is required" },
    },
    {
      fieldName: "Page Title (MS)",
      fieldValue: "field_page_title_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_ms",
      formType: "input",
      label: "Page Title (MS)",
      placeholder: "Enter Page Title (MS)",
      // validation: { required: "Page Title (MS) is required" },
    },
    {
      fieldName: "Page Title (ZH)",
      fieldValue: "field_page_title_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_zh",
      formType: "input",
      label: "Page Title (ZH)",
      placeholder: "Enter Page Title (ZH)",
      // validation: { required: "Page Title (ZH) is required" },
    },
    {
      fieldName: "Page Description (EN)",
      fieldValue: "field_page_description_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_en",
      formType: "richText",
      label: "Page Description (EN)",
      placeholder: "Enter Page Description (EN)",
      // validation: { required: "Page Description (EN) is required" },
    },
    {
      fieldName: "Page Description (MS)",
      fieldValue: "field_page_description_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_ms",
      formType: "richText",
      label: "Page Description (MS)",
      placeholder: "Enter Page Description (MS)",
      // validation: { required: "Page Description (MS) is required" },
    },
    {
      fieldName: "Page Description (ZH)",
      fieldValue: "field_page_description_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_zh",
      formType: "richText",
      label: "Page Description (ZH)",
      placeholder: "Enter Page Description (ZH)",
      // validation: { required: "Page Description (ZH) is required" },
    },
    // {
    //   fieldName: "Metadata Image",
    //   fieldValue: "field_page_metadata_image",
    //   className: "col-span-6",
    //   type: "image",
    //   name: "field_page_metadata_image",
    //   formType: "file",
    //   usedFileType: 'image/*',
    //   label: "Metadata Image",
    //   placeholder: "Enter Metadata Image URL",
    //   validation: { required: "Metadata Image is required" },
    // },
    // {
    //   fieldName: "Metadata Title (EN)",
    //   fieldValue: "field_page_metadata_title_en",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_title_en",
    //   formType: "input",
    //   label: "Metadata Title (EN)",
    //   placeholder: "Enter Metadata Title (EN)",
    //   validation: { required: "Metadata Title (EN) is required" },
    // },
    // {
    //   fieldName: "Metadata Title (MS)",
    //   fieldValue: "field_page_metadata_title_ms",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_title_ms",
    //   formType: "input",
    //   label: "Metadata Title (MS)",
    //   placeholder: "Enter Metadata Title (MS)",
    //   // validation: { required: "Metadata Title (MS) is required" },
    // },
    // {
    //   fieldName: "Metadata Title (ZH)",
    //   fieldValue: "field_page_metadata_title_zh",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_title_zh",
    //   formType: "input",
    //   label: "Metadata Title (ZH)",
    //   placeholder: "Enter Metadata Title (ZH)",
    //   // validation: { required: "Metadata Title (ZH) is required" },
    // },
    // {
    //   fieldName: "Metadata Description (EN)",
    //   fieldValue: "field_page_metadata_desc_en",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_desc_en",
    //   formType: "richText",
    //   label: "Metadata Description (EN)",
    //   placeholder: "Enter Metadata Description (EN)",
    //   validation: { required: "Metadata Description (EN) is required" },
    // },
    // {
    //   fieldName: "Metadata Description (MS)",
    //   fieldValue: "field_page_metadata_desc_ms",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_desc_ms",
    //   formType: "richText",
    //   label: "Metadata Description (MS)",
    //   placeholder: "Enter Metadata Description (MS)",
    //   // validation: { required: "Metadata Description (MS) is required" },
    // },
    // {
    //   fieldName: "Metadata Description (ZH)",
    //   fieldValue: "field_page_metadata_desc_zh",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_desc_zh",
    //   formType: "richText",
    //   label: "Metadata Description (ZH)",
    //   placeholder: "Enter Metadata Description (ZH)",
    //   // validation: { required: "Metadata Description (ZH) is required" },
    // },
  ],
  latestNewsNextPage: [
    {
      fieldName: "Next Page Name (EN)",
      fieldValue: "data.nextPage.name",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_data_nextPage_name",
      formType: "input",
      label: "Next Page Name (EN)",
      placeholder: "Enter content for Next Page Name (EN)",
      validation: { required: "Content for Next Page Name (EN) is required" },
    },
    {
      fieldName: "Next Page Name (MS)",
      fieldValue: "data.nextPage.name",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "content",
      name: "field_content_malay_data_nextPage_name",
      formType: "input",
      label: "Next Page Name (MS)",
      placeholder: "Enter content for Next Page Name (MS)",
      // validation: { required: "Content for Next Page Name (MS) is required" },
    },
    {
      fieldName: "Next Page Name (ZH)",
      fieldValue: "data.nextPage.name",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "content",
      name: "field_content_mandarin_data_nextPage_name",
      formType: "input",
      label: "Next Page Name (ZH)",
      placeholder: "Enter content for Next Page Name (ZH)",
      // validation: { required: "Content for Next Page Name (ZH) is required" },
    },
    {
      fieldName: "Next Page Link",
      fieldValue: "data.nextPage.link",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_data_nextPage_link",
      formType: "input",
      label: "Next Page Link",
      placeholder: "Enter content for Next Page Link",
      validation: {
        required: "Content for Next Page Link is required",
        validate: (value: string) => {
          const trimmed = value.trim();
          if (!trimmed.startsWith("/")) return "Please use an in-app page link, such as /example";
          if (["http://", "https://", "www."].some((p) => trimmed.includes(p))) {
            return "Looks like an external link. Please use an in-app page link, such as /example";
          }
          return true;
        },
      },
    },
  ],
  archivesNewsNextPage: [
    {
      fieldName: "Next Page Name (EN)",
      fieldValue: "data.nextPage.name",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_data_nextPage_name", // ✅ underscore instead of dot
      formType: "input",
      label: "Next Page Name (EN)",
      placeholder: "Enter content for Next Page Name (EN)",
      validation: { required: "Content for Next Page Name (EN) is required" },
    },
    {
      fieldName: "Next Page Name (MS)",
      fieldValue: "data.nextPage.name",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "content",
      name: "field_content_malay_data_nextPage_name", // ✅ underscore
      formType: "input",
      label: "Next Page Name (MS)",
      placeholder: "Enter content for Next Page Name (MS)",
      // validation: { required: "Content for Next Page Name (MS) is required" },
    },
    {
      fieldName: "Next Page Name (ZH)",
      fieldValue: "data.nextPage.name",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "content",
      name: "field_content_mandarin_data_nextPage_name", // ✅ underscore
      formType: "input",
      label: "Next Page Name (ZH)",
      placeholder: "Enter content for Next Page Name (ZH)",
      // validation: { required: "Content for Next Page Name (ZH) is required" },
    },
    {
      fieldName: "Next Page Link",
      fieldValue: "data.nextPage.link",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_data_nextPage_link", // ✅ underscore
      formType: "input",
      label: "Next Page Link",
      placeholder: "Enter content for Next Page Link",
      validation: {
        required: "Content for Next Page Link is required",
        validate: (value: string) => {
          const trimmed = value.trim();
          if (!trimmed.startsWith("/")) return "Please use an in-app page link, such as /example";
          if (["http://", "https://", "www."].some((p) => trimmed.includes(p))) {
            return "Looks like an external link. Please use an in-app page link, such as /example";
          }
          return true;
        },
      },
    },
  ],
};
